module.exports = __webpack_public_path__ + "static/media/logo_cruz.784f55ea.png";